"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectAllBindRefs = exports.extractModelIdsFromActions = exports.extractBindIndexes = exports.extractUpdates = void 0;
const resolvers_1 = require("../utils/resolvers");
const functional_1 = require("./functional");
const extractUpdates = ({ models, modelIds }) => modelIds.reduce((acc, { index, id }) => {
    const model = models[index][id];
    return model.meta && model.meta.updates
        ? [...acc, ...model.meta.updates]
        : acc;
}, []);
exports.extractUpdates = extractUpdates;
const combineBindIndexes = setOfBindIndexes => setOfBindIndexes.reduce((acc, bindIndexes) => {
    if (bindIndexes) {
        bindIndexes.forEach((childFormBindIndexes, childFormIndex) => {
            if (!childFormBindIndexes)
                return;
            if (!Array.isArray(acc[childFormIndex])) {
                acc[childFormIndex] = [];
            }
            acc[childFormIndex].push(...childFormBindIndexes);
        });
    }
    return acc;
}, []);
const sortBindIndexes = setOfBindIndexes => setOfBindIndexes.map(childFormBindIndexes => childFormBindIndexes.sort());
const deduplicateBindIndexes = setOfBindIndexes => setOfBindIndexes.map(childFormBindIndexes => childFormBindIndexes.reduce((acc, index) => !acc.length || acc[acc.length - 1] !== index ? [...acc, index] : acc, []));
const extractBindIndexes = ({ models, modelIds }) => (0, functional_1.pipe)(modelIds.map(({ index, id }) => models[index][id].bindIndexes))(combineBindIndexes, sortBindIndexes, deduplicateBindIndexes);
exports.extractBindIndexes = extractBindIndexes;
const extractModelIdsFromActions = ({ models, 
// these binds are only the binds from the same form the actions came from
binds, actions, repeatIndex, }) => actions.reduce((acc, updateAction) => {
    const ref = (0, resolvers_1.getActiveRef)({
        modelRef: updateAction.modelRef,
        binds,
        bind: updateAction.bind,
        bindIndex: updateAction.bindIndex,
    });
    acc.push(...(0, resolvers_1.resolveModelIds)({ models, modelRef: ref, repeatIndex }));
    return acc;
}, []);
exports.extractModelIdsFromActions = extractModelIdsFromActions;
const collectAllBindRefs = ({ bindIndexes, allBinds }) => bindIndexes.reduce((acc, childFormBindIndexes, formIndex) => {
    acc.push(...childFormBindIndexes.map(index => allBinds[formIndex][index]));
    return acc;
}, []);
exports.collectAllBindRefs = collectAllBindRefs;
//# sourceMappingURL=extract-data.js.map